module.exports = "/foodslaboEf/img/step15/terms_arrow.svg";